/**
 * Determines the environment based on the hostname
 * @returns The environment: "dev", "beta", "prod", "eu", or "uk"
 */
export function getEnvironment(): "dev" | "beta" | "prod" {
  const hostname = window.location.hostname;

  if (
    hostname.includes("dev.ipsosfacto.com") ||
    hostname === "inno.dev.ipsosfacto.com" ||
    hostname === "inno-product.dev.ipsosfacto.com" ||
    hostname === "inno-concept.dev.ipsosfacto.com"
  ) {
    return "dev";
  } else if (
    hostname === "insightsagent.beta.ipsosfacto.com" ||
    hostname === "inno.beta.ipsosfacto.com" ||
    hostname === "inno-product.beta.ipsosfacto.com" ||
    hostname === "inno-concept.beta.ipsosfacto.com"
  ) {
    return "beta";
  } else if (
    hostname === "insightsagent.ipsosfacto.com" ||
    hostname === "inno.ipsosfacto.com" ||
    hostname === "inno-product.ipsosfacto.com" ||
    hostname === "inno-concept.ipsosfacto.com"
  ) {
    return "prod";
  }

  // Default to dev for local development
  return "dev";
}
